import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { sessionQueries } from '@/api';
import { ErrorScreen } from '@/components/error-screen';
import { OperatorShell } from '@/features/operator/shell/operator-shell';

/**
 * Один безшляховий маршрут захищає всі операторські сторінки (§10.6 гайду):
 * нова сторінка під _operator/ не потребує жодного коду про права.
 * Це лише навігація; справжня перевірка прав — OperatorGuard на бекенді.
 *
 * Він же малює каркас (бічна панель, пошук): вхід живе поза ним і
 * лишається окремим екраном.
 */
export const Route = createFileRoute('/_operator')({
	beforeLoad: async ({ context }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueries.current());
		if (!session) throw redirect({ to: '/login', search: {} });
		if (session.user.role !== 'OPERATOR') throw redirect({ to: '/login', search: { error: 'operator' } });
	},
	component: () => (
		<OperatorShell>
			<Outlet />
		</OperatorShell>
	),
	// Помилка сторінки не гасить каркас: оператор перейде на іншу, не перезавантажуючи вкладку.
	errorComponent: ({ error }) => (
		<OperatorShell>
			<ErrorScreen error={error} />
		</OperatorShell>
	),
});

